import { Injectable } from "@angular/core";
import { Router, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, NavigationExtras } from '@angular/router';

import { UserAuth } from "@nrwl/common-lib";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuardService implements CanActivate {
  constructor(
    public router: Router,
    public userAuth: UserAuth) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const routeParams: NavigationExtras = {};
    if (route.queryParams) {
      routeParams.queryParams = {};
      routeParams.queryParams['returnUrl'] = state.url;
    }

    if (this.hasUserToken()) {
      return true;
    }
    else {
      this.router.navigate(['signin'], routeParams);
      return false;
    }
  }

  hasUserToken(): boolean {
    const user = sessionStorage.getItem(this.userAuth.STORAGE_KEY);
    if (user) {
      const userJson = JSON.parse(user);
      if (userJson.token) {
        return true;
      }
    }
    return false;
  }
}
